import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {
    aggregateHardawareDetailDevice,
    peiodicDataElementType, peiodicDataElementTypeValue
} from "../../providers/service/global-variables.service";
import {IconService} from "../../providers/service/icon.service";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'app-box-heat-pump',
    templateUrl: './box-heat-pump.component.html',
    styleUrls: ['./box-heat-pump.component.scss'],
    standalone: false
})
export class BoxHeatPumpComponent implements OnInit {

    @Input() device: aggregateHardawareDetailDevice | undefined;
    @Input() loadValue: boolean | undefined;
    @Output() clickSetting = new EventEmitter();
    @Output() clickTemperature = new EventEmitter();
    typeSensorData = peiodicDataElementType;
    peiodicDataElementTypeValue = peiodicDataElementTypeValue;

    constructor(
        private matDialog: MatDialog,
        private iconService: IconService) {
        this.iconService.addSvgIcon('ecology', 'assets/icon/co2/ecology.svg');
    }

    settingTemperature: number | undefined;
    currentTemperature: number | undefined;
    title: string | undefined;
    IS_ON = false;
    IS_ACS_ON = false;
    IS_ECO_MODE = false;
    resizeClass = '';
    icons: { key: string, icon: string | undefined, svgIcon: string | undefined, isSet: boolean }[] = [];


    getSensorDataValue(device: aggregateHardawareDetailDevice, key: string): boolean | number | undefined {
        const index = device.sensorDataTypes.findIndex(type => type === key);
        if (index >= 0) {
            if ((this.peiodicDataElementTypeValue as any)[key] === 'BOOL') {
                return device.sensorDataValues[index] === 1;
            } else if ((this.peiodicDataElementTypeValue as any)[key] === 'NUMBER') {
                return Math.round(device.sensorDataValues[index] * 10) / 10;
            } else {
                return device.sensorDataValues[index];
            }
        } else {
            return undefined;
        }
    }


    ngOnInit(): void {
        if (this.device) {
            this.title = this.device.name;
            const settingTemperature = this.getSensorDataValue(this.device, this.typeSensorData.SET_POINT_H20_MANDATA.key);
            const currentTemperature = this.getSensorDataValue(this.device, this.typeSensorData.TEMPERATURE_H20_MANDATA.key);
            if (typeof settingTemperature === 'number') {
                this.settingTemperature = this.getSensorDataValue(this.device, this.typeSensorData.SET_POINT_H20_MANDATA.key) as number;
            }
            if (typeof currentTemperature === 'number') {
                this.currentTemperature = this.getSensorDataValue(this.device, this.typeSensorData.TEMPERATURE_H20_MANDATA.key) as number;
            }

            this.device.sensorDataTypes.forEach((key, index) => {
                const value = (this.typeSensorData as any)[key]
                const objIcon: { key: string, svgIcon: undefined | string, icon: undefined | string, isSet: boolean } = {
                    key,
                    svgIcon: undefined,
                    icon: undefined,
                    isSet: false
                };
                if (value != null) {
                    if (value.icon) {
                        objIcon.icon = value.icon;
                    }
                    if (value.svgIcon) {
                        objIcon.svgIcon = this.iconService.addSvgIcon('icon_name_' + index, value.svgIcon);
                    }

                    if (objIcon.svgIcon != null || objIcon.icon != null) {
                        const value = this.getSensorDataValue(this.device!, key);
                        objIcon.isSet = typeof value === 'boolean' ? value : value != null;
                        this.icons.push(objIcon);
                    }
                }
            });
            this.IS_ON = this.getSensorDataValue(this.device, this.typeSensorData.IS_ON.key) as boolean;
            this.IS_ACS_ON = this.getSensorDataValue(this.device, this.typeSensorData.IS_ACS_ON.key) as boolean;
            this.IS_ECO_MODE = this.getSensorDataValue(this.device, this.typeSensorData.IS_ECO_MODE.key) as boolean;
        }
    }

    color(value: boolean): 'accent' | undefined {
        return (value) ? 'accent' : undefined;
    }


    openSettings(): void {
        if (!this.loadValue) {
            this.clickSetting.emit();
        }
    }

    openTemperature(): void {
        if (!this.loadValue) {
            this.clickTemperature.emit();
        }
    }
}
